(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        enumsColors(
            module.exports
        );

    } else {
        RivalIQ.module('enums');

        enumsColors(
            RivalIQ.enums
        );
    }

    function enumsColors(exports) {

        exports.colors = {
            black: 'rgb(0,0,0)',
            orange: 'rgb(248, 167, 65)',
            lightYellow: 'rgb(249, 226, 125)',
            lightBlue: 'rgb(93, 196, 252)',
            blue: 'rgb(39, 146, 207)',
            royalBlue: '#1f77b4',
            green: '#7ab430',
            competitor: '#6A788C',
            focus: '#64B0E8',
            facebookHighContrast: 'rgb(39, 75, 130)',
            twitterHighContrast: 'rgb(98, 194, 245)',
            instagramHighContrast: 'rgb(80, 125, 162)',
            youTubeHighContrast: 'rgb(255, 0, 0)',
            tiktokHighContrast: '#43DDF2',
            progressBarBlue: '#2A769E',
            female: 'rgb(212, 103, 155)',
            male: 'rgb(102, 182, 227)',
            unspecified: 'rgb(249, 226, 125)'
        };
    }
})();
